import { useEffect, useRef, useState } from "react";
import logo from "../logo.svg";
import "../App.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabMenu } from "primereact/tabmenu";
import {
  CreateUser,
  DeleteUser,
  GetDevice,
  GetTestDevice,
  GetUser,
  GetUsers,
  LogOut,
} from "../api";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { CascadeSelect } from "primereact/cascadeselect";
import { useAsyncEffect } from "../hooks/useAsyncEffect";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { setArrayTests, setUser, setUsers } from "../store/actions";
import { OverlayPanel } from "primereact/overlaypanel";
import { IonInput, IonToast } from "@ionic/react";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import Highlighter from "react-highlight-words";
import { Button } from "primereact/button";

const Tables = () => {
  const info = useSelector((state) => state.info);
  const token = useSelector((state) => state.token);
  const statuses = useSelector((state) => state.statuses);
  const user = useSelector((state) => state.user);
  const users = useSelector((state) => state.users);

  const [valueReport, setValueReport] = useState();
  const [valueDateOt, setValueDateOt] = useState();
  const [valueDateDo, setValueDateDo] = useState();

  const [valueCreateUsers, setValueCreateUsers] = useState({
    email: null,
    password: null,
    name: null,
    surname: null,
    roles_id: null,
  });

  const [searchValue, setSearchValue] = useState();
  const [openToast, setOpenToast] = useState(false);
  const [openModalUsers, setOpenModalUsers] = useState(false);

  // const statuses = [
  //   {
  //     name: "Напечатали этикетку",
  //     id: 11,
  //   },
  //   {
  //     name: "Второе тестирование ок",
  //     id: 9,
  //   },
  //   {
  //     name: "Все",
  //     id: 0,
  //   },
  // ];

  const [selectStatus, setSelectStatus] = useState(statuses?.[0]);

  const devices = [
    {
      cname: "Все",
      code: "all",
      type: 0,
    },
    {
      name: "БЭГ",
      code: "1",
      types: [
        {
          cname: "БЭГ - Все",
          code: "11",
          type: 1,
        },
        {
          cname: "БЭГ - Готовые",
          code: "12",
          type: 1,
        },
      ],
    },
    {
      name: "БИП",
      code: "2",
      types: [
        {
          cname: "БИП - Все",
          code: "21",
          type: 2,
        },
        {
          cname: "БИП - Готовые",
          code: "22",
          type: 2,
        },
      ],
    },
    {
      name: "Антенна",
      code: "3",
      types: [
        {
          cname: "Антенна - Все",
          code: "31",
          type: 3,
        },
        {
          cname: "Антенна - Готовые",
          code: "32",
          type: 3,
        },
      ],
    },
    {
      name: "Громкоговоритель",
      code: "4",
      types: [
        {
          cname: "Громкоговоритель - Все",
          code: "41",
          type: 4,
        },
        {
          cname: "Громкоговоритель - Готовые",
          code: "42",
          type: 4,
        },
      ],
    },
  ];

  const roleUsers = [
    { name: "Пользователь", role: 1 },
    { name: "Администратор", role: 100 },
  ];

  const [selectRoleUsers, setSelectRoleUsers] = useState(roleUsers?.[0]);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTypeDevice, setSelectedTypeDevice] = useState();
  const [arrayDevice, setArrayDevice] = useState([]);
  // const [arrTests, setArrTests] = useState([]);
  const dispatch = useDispatch();
  const arrTests = useSelector((state) => state.arrayTests);
  const [expandedRows, setExpandedRows] = useState(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [arrModal, setArrModal] = useState([]);
  const [idDelete, setIdDelete] = useState();

  useAsyncEffect(async () => {
    await GetUser(token, info).then((e) => {
      dispatch(setUser(e.data.data.res));
    });
  }, []);

  const onRowExpand = (event) => {
    // let filter = arrTests.filter((e) => e.length && e[0].uid !== event.data.uid);
    // let filter2 = filter.filter((e) => e.length && e[0].uid_ !== event.data.uid);
    // dispatch(setArrayTests(filter2));
  };

  const onRowCollapse = (event) => {
    let filter = arrTests.filter((e) => e.length && e[0].uid !== event.data.uid);
    let filter2 = filter.filter((e) => e.length && e[0].uid_ !== event.data.uid);
    dispatch(setArrayTests(filter2));
  };

  const allowExpansion = async (rowData) => {
    let test = await GetTestDevice(token, info, rowData.uid);
    test.data.data.tests.forEach((l) => {
      l.json_res = JSON.parse(l.json_res);
      l.uid = rowData.uid;
    });
    let arr = arrTests;
    if (!test.data.data.tests.length) {
      arr.push([{ uid_: rowData.uid }]);
    } else {
      arr.push(test.data.data.tests);
    }
    dispatch(setArrayTests(arr));
    return rowData.uid;
  };

  const statusTemplate = (rowData) => {
    return (
      <div
        className={`btn-table ${Object.keys(rowData.json_res).length ? "link" : ""}`}
        onClick={() => {
          if (Object.keys(rowData.json_res).length) {
            setDialogVisible(true);
            setArrModal(Object.values(rowData.json_res));
          }
        }}
      >
        {rowData.status}
      </div>
    );
  };

  const rowExpansionTemplate = (data) => {
    let forTable = arrTests.filter((q) => q.length && q[0].uid === data.uid)[0];
    let empty = arrTests.filter((q) => q.length && q[0].uid_ === data.uid);
    return (
      <>
        {!forTable?.length ? (
          <>
            {!empty?.length ? (
              <div className="spinner">
                <ProgressSpinner
                  style={{ width: "50px", height: "50px" }}
                  strokeWidth="5"
                  stroke="black"
                  fill="white"
                  animationDuration="7.1s"
                />
              </div>
            ) : (
              <div className="spinner">Нет данных</div>
            )}
          </>
        ) : (
          <div className="p-3">
            <h5>Пройденные тесты</h5>
            <DataTable emptyMessage="Нет данных" removableSort value={forTable}>
              <Column field="id" header="Номер тестирования" sortable></Column>
              <Column field="create_at" header="Дата тестирования" sortable></Column>
              <Column field="status" header="Статус" body={statusTemplate} sortable></Column>
              {/* <Column headerStyle={{ width: "4rem" }}></Column> */}
            </DataTable>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    let type = selectedTypeDevice
      ? selectedTypeDevice.type === 1
        ? 1
        : selectedTypeDevice.type === 2
        ? 2
        : selectedTypeDevice.type === 3
        ? 3
        : selectedTypeDevice.type === 4 && 4
      : 0;
    let offset = (currentPage - 1) * 10;
    let status_id =
      selectedTypeDevice &&
      (selectedTypeDevice.code === "12" ||
        selectedTypeDevice.code === "22" ||
        selectedTypeDevice.code === "32" ||
        selectedTypeDevice.code === "42")
        ? 11
        : undefined;

    let search = searchValue ? searchValue : undefined;
    const intervalId = setInterval(() => {
      GetDevice(token, info, 10, offset, type, status_id, search).then((e) => {
        if (e.data.status === 4) {
          localStorage.clear();
          history.push("/login");
        }
        e.data.data.device?.forEach((l) => {
          let msec_create_at = new Date(l.create_at).getTime();
          l.create_at = new Date(msec_create_at + 10800000).toLocaleString();
          if (!l.update_at) {
            l.update_at = l.create_at;
          } else {
            let msec_update_at = new Date(l.update_at).getTime();
            l.update_at = new Date(msec_update_at + 10800000).toLocaleString();
          }
          l.alias = l?.alias.slice(1, l.alias.length - 1);

          if (l.info) {
            let inf = JSON.parse(l.info);
            l.imei = inf.imei;
            l.iccid1 = inf.iccid1;
            l.iccid2 = inf.iccid2;
            l.serial_number = inf.serial_number;
          }
        });
        setArrayDevice(e.data.data.device);
      });
    }, 5000);
    GetDevice(token, info, 10, offset, type, status_id, search).then((e) => {
      if (e.data.status === 4) {
        localStorage.clear();
        history.push("/login");
      }
      e.data.data.device?.forEach((l) => {
        let msec_create_at = new Date(l.create_at).getTime();
        l.create_at = new Date(msec_create_at + 10800000).toLocaleString();
        if (!l.update_at) {
          l.update_at = l.create_at;
        } else {
          let msec_update_at = new Date(l.update_at).getTime();
          l.update_at = new Date(msec_update_at + 10800000).toLocaleString();
        }
        l.alias = l?.alias.slice(1, l.alias.length - 1);
        if (l.info) {
          let inf = JSON.parse(l.info);
          l.imei = inf.imei;
          l.iccid1 = inf.iccid1;
          l.iccid2 = inf.iccid2;
          l.serial_number = inf.serial_number;
        }
      });
      setArrayDevice(e.data.data.device);
    });
    return () => clearInterval(intervalId);
  }, [selectedTypeDevice, currentPage, searchValue]);

  const op = useRef();
  const addUser = useRef();
  const deleteQuest = useRef();

  useEffect(() => {
    console.log(user);

    if (user.roles_id === 100) {
      GetUsers(token, info).then((e) => {
        e.data.data.res?.forEach((el, i) => {
          el.role =
            el.roles_id === 1 ? "Пользователь" : el.roles_id === 100 ? "Администратор" : null;
        });
        let filter = e.data.data.res.filter((q) => q.status !== 0);
        dispatch(setUsers(filter));
      });
    }
  }, [addUser, user]);

  const history = useHistory();

  // const CreateReport = (value) => {
  //   let status = selectStatus?.status;
  //   GetDevice(token, info, +value, 0, 1, status).then(async (e) => {
  //     await e.data.data.device?.forEach((l) => {
  //       let msec_create_at = new Date(l.create_at).getTime();
  //       l.create_at = new Date(msec_create_at + 10800000).toLocaleString();
  //       if (!l.update_at) {
  //         l.update_at = l.create_at;
  //       } else {
  //         let msec_update_at = new Date(l.update_at).getTime();
  //         l.update_at = new Date(msec_update_at + 10800000).toLocaleString();
  //       }
  //       l.alias = l?.alias.slice(1, l.alias.length - 1);
  //       if (l.info) {
  //         let inf = JSON.parse(l.info);
  //         l.imei = inf.imei;
  //         l.iccid1 = inf.iccid1;
  //         l.iccid2 = inf.iccid2;
  //         l.serial_number = inf.serial_number;
  //       }
  //       delete l.info;
  //     });
  //     await e.data.data.device.forEach(async (l) => {
  //       await GetTestDevice(token, info, l.uid).then((d) => {
  //         let test = d.data.data.tests;
  //         test.forEach((s) => {
  //           s.json_res = JSON.parse(s.json_res);
  //           s.uid = l.uid;
  //         });
  //         l.user = test?.[0]?.json_res?.[0].user;
  //       });
  //     });
  //     console.log(e.data.data.device);

  //     await exportExcel(e.data.data.device);
  //   });
  // };
  const CreateReport = async (value) => {
    let status = selectStatus?.id;
    try {
      const e = await GetDevice(
        token,
        info,
        +value,
        0,
        1,
        status,
        undefined,
        valueDateOt ? valueDateOt : undefined,
        valueDateDo ? valueDateDo : undefined
      );
      console.log(e.data.data.device);
      e.data.data.device?.forEach((l) => {
        // let msec_create_at = new Date(l.create_at).getTime();
        // l.create_at = new Date(msec_create_at + 10800000).toLocaleString();
        // if (!l.update_at) {
        //   l.update_at = l.create_at;
        // } else {
        //   let msec_update_at = new Date(l.update_at).getTime();
        //   l.update_at = new Date(msec_update_at + 10800000).toLocaleString();
        // }
        l.alias = l?.alias.slice(1, l.alias.length - 1);
        if (l.info) {
          let inf = JSON.parse(l.info);
          let td = JSON.parse(l.td_json_res);
          l.imei = inf.imei;
          l.iccid1 = inf.iccid1;
          l.iccid2 = inf.iccid2;
          l.serial_number = inf.serial_number;
          l.user = td[0].user;
          l.uveos_ver = inf.uveos_ver;
        }
        delete l.td_json_res;
        delete l.info;
      });

      // await Promise.all(
      //   e.data.data.device.map(async (l) => {
      //     const d = await GetTestDevice(token, info, l.uid);
      //     let test = d.data.data.tests;
      //     test.forEach((s) => {
      //       s.json_res = JSON.parse(s.json_res);
      //       s.uid = l.uid;
      //     });
      //     l.user = test?.[0]?.json_res?.[0].user;
      //   })
      // );

      if (!e.data.data.device.length) {
        setOpenToast(true);
      }
      await exportExcel(e.data.data.device);
    } catch (error) {
      console.error("Ошибка генерации таблицы", error);
      setOpenToast(true);
    }
  };

  const exportExcel = (value) => {
    if (!value.length) {
      return;
    }
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(value);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, `report_${Date.now()}_status_${selectStatus?.status}`);
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        // module.default.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
        module.default.saveAs(data, fileName);
      }
    });
  };

  const HighlightedCell = ({ value, searchTerm }) => {
    return (
      <Highlighter
        highlightClassName="highlight"
        searchWords={[searchTerm]}
        autoEscape={true}
        textToHighlight={value || ""}
      />
    );
  };

  const serialNumberTemplate = (rowData) => {
    return <HighlightedCell value={rowData.serial_number} searchTerm={searchValue} />;
  };

  const aliasTemplate = (rowData) => {
    return <HighlightedCell value={rowData.alias} searchTerm={searchValue} />;
  };

  const ccid1Template = (rowData) => {
    return <HighlightedCell value={rowData.iccid1} searchTerm={searchValue} />;
  };

  const ccid2Template = (rowData) => {
    return <HighlightedCell value={rowData.iccid2} searchTerm={searchValue} />;
  };

  const imeiTemplate = (rowData) => {
    return <HighlightedCell value={rowData.imei} searchTerm={searchValue} />;
  };

  const onCreateUser = async (e) => {
    let forSend = e;
    forSend.roles_id = selectRoleUsers.role;
    CreateUser(token, info, forSend).then(async (q) => {
      await GetUsers(token, info).then((e) => {
        e.data.data.res.forEach((el, i) => {
          el.role =
            el.roles_id === 1 ? "Пользователь" : el.roles_id === 100 ? "Администратор" : null;
        });
        let filter = e.data.data.res.filter((s) => s.status !== 0);
        dispatch(setUsers(filter));
      });
      setSelectRoleUsers(roleUsers?.[0]);
      setValueCreateUsers({
        email: null,
        password: null,
        name: null,
        surname: null,
        roles_id: null,
      });
    });
  };

  const onDeleteUser = async (id) => {
    DeleteUser(token, info, id).then(async (e) => {
      await GetUsers(token, info).then((q) => {
        q.data.data.res.forEach((el, i) => {
          el.role =
            el.roles_id === 1 ? "Пользователь" : el.roles_id === 100 ? "Администратор" : null;
        });
        let filter = q.data.data.res?.filter((s) => s.status !== 0);
        dispatch(setUsers(filter));
      });
    });
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap gap-2">
        <div
          className={`button-logout`}
          onClick={(q) => {
            // onDeleteUser(rowData)
            setIdDelete(rowData.id);
            deleteQuest.current.toggle(q);
          }}
        >
          Х
        </div>
      </div>
    );
  };

  return (
    <div className="App">
      <div className="header">
        {user?.roles_id === 100 && (
          <div
            className="button-logout"
            onClick={async () => {
              await setSelectRoleUsers(roleUsers?.[0]);
              await setValueCreateUsers({
                email: null,
                password: null,
                name: null,
                surname: null,
                roles_id: null,
              });
              setOpenModalUsers(true);
            }}
          >
            Пользователи
          </div>
        )}
        <div className="right">
          <div
            className={`button-logout`}
            onClick={async () => {
              await LogOut(token, localStorage.getItem("info")).then((e) => {
                if (!e.data.error) {
                  localStorage.clear();
                  history.push("/login");
                }
                if (e.data.status === 4) {
                  localStorage.clear();
                  history.push("/login");
                }
              });
            }}
          >
            Выйти
          </div>
        </div>
      </div>
      <div className="control">
        <div className="left">
          <CascadeSelect
            value={selectedTypeDevice}
            onChange={(e) => {
              setCurrentPage(1);
              setSelectedTypeDevice(e.value);
            }}
            options={devices}
            optionLabel="cname"
            optionGroupLabel="name"
            optionGroupChildren={["types"]}
            className="w-full md:w-14rem"
            breakpoint="767px"
            placeholder="Выберите тип устройства"
            style={{ minWidth: "14rem" }}
          />
          <div className="input-cont">
            <input
              placeholder="Поиск"
              defaultValue={searchValue}
              onChange={(e) => {
                setCurrentPage(1);
                setSearchValue(e.target.value);
              }}
              className="input-search"
            />
          </div>
        </div>
        <div
          className="btn"
          onClick={async (e) => {
            await setValueReport();
            await setValueDateOt();
            await setValueDateDo();
            op.current.toggle(e);
          }}
        >
          Отчёт (БЭГ)
        </div>
      </div>

      <DataTable
        emptyMessage="Нет данных"
        rowExpansionTemplate={rowExpansionTemplate}
        onRowExpand={onRowExpand}
        onRowCollapse={onRowCollapse}
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        removableSort
        value={arrayDevice}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column expander={allowExpansion} style={{ width: "5rem" }} />
        <Column field="name" sortable header="Тип устройства"></Column>
        <Column field="update_at" sortable header="Дата последнего теста"></Column>
        <Column
          field="serial_number"
          sortable
          header="Серийный №"
          body={serialNumberTemplate}
        ></Column>
        <Column field="alias" sortable header="Номер платы" body={aliasTemplate}></Column>
        <Column field="status" sortable header="Статус"></Column>

        {(!selectedTypeDevice ||
          selectedTypeDevice.type === 0 ||
          selectedTypeDevice.type === 1) && (
          <Column field="iccid1" sortable header="CCID 1" body={ccid1Template}></Column>
        )}
        {(!selectedTypeDevice ||
          selectedTypeDevice.type === 0 ||
          selectedTypeDevice.type === 1) && (
          <Column field="iccid2" sortable header="CCID 2" body={ccid2Template}></Column>
        )}
        {(!selectedTypeDevice ||
          selectedTypeDevice.type === 0 ||
          selectedTypeDevice.type === 1) && (
          <Column field="imei" sortable header="IMEI" body={imeiTemplate}></Column>
        )}
      </DataTable>
      <div className="paginator">
        <button
          disabled={currentPage <= 1}
          className="btn"
          onClick={() => {
            setCurrentPage(currentPage - 1);
            dispatch(setArrayTests([]));
          }}
        >
          {"<"}
        </button>
        <div className="text">{currentPage}</div>
        <button
          disabled={arrayDevice?.length < 10}
          className="btn"
          onClick={() => {
            dispatch(setArrayTests([]));
            setCurrentPage(currentPage + 1);
          }}
        >
          {">"}
        </button>
      </div>
      <Dialog
        header="Этапы тестирования"
        visible={dialogVisible}
        style={{ width: "98vw" }}
        maximizable
        modal
        contentStyle={{ height: "600px" }}
        onHide={() => setDialogVisible(false)}
      >
        <div className="dialog-background">
          <DataTable
            emptyMessage="Нет данных"
            value={arrModal}
            scrollable
            scrollHeight="flex"
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column field="name" header="Название" style={{ width: "30rem" }}></Column>
            <Column field="message" header="Сообщение" style={{ width: "50rem" }}></Column>
            <Column field="state" header="Статус"></Column>
            <Column field="user" header="Имя пользователя"></Column>
          </DataTable>
        </div>
      </Dialog>
      <Dialog
        header="Пользователи"
        visible={openModalUsers}
        style={{ width: "98vw" }}
        maximizable
        modal
        contentStyle={{
          height: "600px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
        onHide={() => setOpenModalUsers(false)}
      >
        <div className="line-sett">
          <div
            className="button-logout"
            onClick={(e) => {
              addUser.current.toggle(e);
            }}
          >
            Добавить пользователя
          </div>
        </div>
        <div className="dialog-background">
          <DataTable
            emptyMessage="Нет данных"
            value={users}
            scrollable
            scrollHeight="flex"
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column field="id" header="ID" style={{ width: "30rem" }} sortable></Column>
            <Column field="email" header="Логин" style={{ width: "30rem" }} sortable></Column>
            <Column field="role" header="Роль" style={{ width: "50rem" }} sortable></Column>
            <Column field="name" header="Имя" style={{ width: "30rem" }} sortable></Column>
            <Column field="surname" header="Фамилия" style={{ width: "30rem" }} sortable></Column>
            <Column body={actionTemplate} headerClassName="w-10rem" />
          </DataTable>
          <OverlayPanel ref={deleteQuest} className="overlay-layer-add-user">
            <div className="const-layer-list">
              <div style={{ width: "100%", textAlign: "center" }}>Удалить пользователя?</div>
              <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                <div
                  className="btn btn-report"
                  onClick={(e) => {
                    onDeleteUser(idDelete);
                    deleteQuest.current.toggle(e);
                  }}
                >
                  Удалить
                </div>
                <div
                  className="btn btn-report"
                  onClick={(e) => {
                    onCreateUser(valueCreateUsers);
                    deleteQuest.current.toggle(e);
                  }}
                >
                  Отмена
                </div>
              </div>
            </div>
          </OverlayPanel>
          <OverlayPanel ref={addUser} className="overlay-layer-add-user">
            <div className="const-layer-list">
              <div className="cont-input">
                <div className="upper-text">Логин</div>
                <IonInput
                  value={valueCreateUsers.email}
                  fill="outline"
                  placeholder="Введите логин"
                  onInput={(e) =>
                    setValueCreateUsers({ ...valueCreateUsers, email: e.target.value })
                  }
                  className="input-report"
                ></IonInput>
              </div>
              <div className="cont-input">
                <div className="upper-text">Пароль</div>
                <IonInput
                  value={valueCreateUsers.password}
                  fill="outline"
                  placeholder="Придумайте пароль"
                  onInput={(e) =>
                    setValueCreateUsers({ ...valueCreateUsers, password: e.target.value })
                  }
                  className="input-report"
                ></IonInput>
              </div>
              <Dropdown
                value={selectRoleUsers}
                onChange={(e) => setSelectRoleUsers(e.value)}
                options={roleUsers}
                optionLabel="name"
                placeholder="Выберите роль"
                className="w-full md:w-14rem"
              />
              <div className="cont-input">
                <div className="upper-text">Имя</div>
                <IonInput
                  value={valueCreateUsers.name}
                  fill="outline"
                  placeholder="Введите имя"
                  onInput={(e) =>
                    setValueCreateUsers({ ...valueCreateUsers, name: e.target.value })
                  }
                  className="input-report"
                ></IonInput>
              </div>
              <div className="cont-input">
                <div className="upper-text">Фамилия</div>
                <IonInput
                  value={valueCreateUsers.surname}
                  fill="outline"
                  placeholder="Введите фамилию"
                  onInput={(e) =>
                    setValueCreateUsers({ ...valueCreateUsers, surname: e.target.value })
                  }
                  className="input-report"
                ></IonInput>
              </div>
              <div
                className="btn btn-report"
                onClick={(e) => {
                  onCreateUser(valueCreateUsers);
                  addUser.current.toggle(e);
                }}
              >
                Создать
              </div>
            </div>
          </OverlayPanel>
        </div>
      </Dialog>
      <OverlayPanel ref={op} className="overlay-layer">
        <div className="const-layer-list">
          <div className="cont-input">
            <IonInput
              value={valueReport}
              fill="outline"
              placeholder="Кол-во устройств"
              onInput={(e) => setValueReport(e.target.value)}
              className="input-report"
            ></IonInput>
          </div>
          <Dropdown
            value={selectStatus}
            onChange={(e) => setSelectStatus(e.value)}
            options={statuses}
            optionLabel="name"
            placeholder="Выберите статус"
            className="w-full md:w-14rem"
          />
          <div className="cont-input">
            <div className="upper-text"> От</div>
            <IonInput
              type="date"
              value={valueDateOt}
              fill="outline"
              placeholder="Кол-во устройств"
              onInput={(e) => setValueDateOt(e.target.value)}
              className="input-report"
            ></IonInput>
          </div>
          <div className="cont-input">
            <div className="upper-text"> До</div>
            <IonInput
              type="date"
              value={valueDateDo}
              fill="outline"
              placeholder="Кол-во устройств"
              onInput={(e) => {
                setValueDateDo(e.target.value);
              }}
              className="input-report"
            ></IonInput>
          </div>
          <div
            className="btn btn-report"
            onClick={(e) => {
              CreateReport(valueReport);
              op.current.toggle(e);
            }}
          >
            Сформировать
          </div>
        </div>
      </OverlayPanel>

      <IonToast
        isOpen={openToast}
        onDidDismiss={() => setOpenToast(false)}
        message="Ошибка при создании отчета"
        position="top"
        color="primary"
        mode="ios"
        duration="5000"
      ></IonToast>
      <Highlighter
        highlightClassName="YourHighlightClass"
        searchWords={[searchValue]}
        autoEscape={true}
        // textToHighlight="111"
      />
    </div>
  );
};

export default Tables;
